<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <b-tabs v-model="tab">
            <b-tab :title="$t('edu_contents.all')"  >
              <data-table :edit-item="editItem" />
            </b-tab>
            <b-tab @click="newItem= {}" :title="$t('site.add')">
              <my-form :new-item="newItem"  />
            </b-tab>
          </b-tabs>
        </div>
        <!-- end of card body -->
      </div>
      <!-- end of card -->
    </div>
    <!-- end of col -->
  </div>
</template>

<script>
import DataTableVue from "./components/ContentsDataTable.vue";
import FormVue from "./components/Contents.vue";

export default {
  name: "EduContentsIndex",
  components: {
    "data-table": DataTableVue,
    "my-form": FormVue,
  },
  data() {
    return {
      newItem: {},
      tab: 0,
     };
  },
  methods: {
    editItem(data) {
      delete this.newItem.introductory_file;
      this.newItem = data;

      this.tab = 1;
    },
  },
};
</script>
